import { render, staticRenderFns } from "./StaticView.vue?vue&type=template&id=692588ec&scoped=true"
import script from "./StaticView.vue?vue&type=script&lang=js"
export * from "./StaticView.vue?vue&type=script&lang=js"
import style0 from "./StaticView.vue?vue&type=style&index=0&id=692588ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692588ec",
  null
  
)

export default component.exports